import { render, staticRenderFns } from "./RegistrarPontoFuncionario.vue?vue&type=template&id=43e15a0c"
import script from "./RegistrarPontoFuncionario.vue?vue&type=script&lang=js"
export * from "./RegistrarPontoFuncionario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports